import { deepMerge as r } from "./deepMerge.js";
function i(e) {
  return r(e ?? {}, {
    info: {
      title: "",
      description: "",
      termsOfService: "",
      version: "",
      license: {
        name: "",
        url: ""
      },
      contact: {
        email: ""
      }
    },
    externalDocs: {
      description: "",
      url: ""
    },
    servers: [],
    tags: []
  });
}
export {
  i as createEmptySpecification
};
